import { render, staticRenderFns } from "./BaseLoadingTable.vue?vue&type=template&id=40aa1838&"
import script from "./BaseLoadingTable.vue?vue&type=script&lang=js&"
export * from "./BaseLoadingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports